export { default } from './DialogTitle';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/DialogTitle/index.js
// module id = 821
// module chunks = 2